import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ContactListPage" */
	'pages/supplier/Contact/ContactListPage'));

export default [{ component, exact: true, path: '/supplier_contacts' }];